/**
 * NestorMark — wordmark logo Editorial Operations (HiFi.3).
 *
 * Le mot « Nestor » en DM Serif Display avec un petit point éditorial
 * flottant au-dessus du « e » (référence : « le toit du foyer », mais
 * se lit avant tout comme un accent typographique).
 *
 * Deux variantes :
 *   - `wordmark` : « Nestor » + dot. Pour la sidebar desktop et
 *     l'onboarding (étapes 1-2).
 *   - `mark`     : « N » + dot. Pour les avatars favicon ou les
 *     contextes très contraints (encoche mobile).
 *
 * La couleur est héritée via `currentColor`. Pour la mettre en
 * accent (sage/slate), positionner `color` sur le parent.
 */
import { html, type TemplateResult } from 'lit-html';
import styles from './editorial.module.css';

export interface NestorMarkProps {
  /** Variante affichage. Default : `wordmark`. */
  variant?: 'wordmark' | 'mark';
  /** Taille font-size en px (le point dérive proportionnellement). */
  size?: number;
  /** testid optionnel. */
  testid?: string;
}

export function nestorMark(props: NestorMarkProps = {}): TemplateResult {
  const { variant = 'wordmark', size = 24, testid } = props;
  // Le dot fait 13 % de la taille du wordmark, 16 % pour la mark seule.
  const dotSize = variant === 'wordmark' ? size * 0.13 : size * 0.16;
  const dotTop = variant === 'wordmark' ? -size * 0.18 : -size * 0.12;
  const dotLeft = variant === 'wordmark' ? size * 0.4 : size * 0.36;
  const dotStyle = `top: ${dotTop}px; left: ${dotLeft}px; width: ${dotSize}px; height: ${dotSize}px;`;
  const word = variant === 'wordmark' ? 'Nestor' : 'N';
  return html`<span class=${styles.mark} data-testid=${testid ?? 'nestor-mark'}>
    <span class=${styles.markWord} style="font-size: ${size}px">
      ${word}
      <span class=${styles.markDot} style=${dotStyle}></span>
    </span>
  </span>`;
}
